export default __webpack_public_path__ + "images/7f4ccf19c5013d7e36de5f163eae3735.png";